// import React, { useRef, useEffect, useState } from "react";
// import L from "leaflet";
// import { MapContainer, TileLayer } from "react-leaflet";
// import "leaflet-routing-machine/dist/leaflet-routing-machine.css";
// import "leaflet-routing-machine";
// import "leaflet/dist/leaflet.css";
// import "leaflet-routing-machine/dist/leaflet-routing-machine.css";
// import { Spin } from "antd";
// import { useSelector } from "react-redux";

// import { generateRandomColor } from "../../../util/helper";

// const MapComponent = ({ response, data }) => {
//   const mapRef = useRef(null);
//   const routingControlRef = useRef(null);

//   const { FirstExportData } = useSelector((state) => ({
//     FirstExportData: state.relay.getMapCoord.FirstExportData,
//   }));

//   const [loading, setLoading] = useState(false);

//   const customIcon = (count) => {
//     const svgTemplate = `
//       <svg xmlns="http://www.w3.org/2000/svg" width="50" height="65" viewBox="0 0 50 65">
//         <path fill="#FF0000" d="M25 0C11.191 0 0 11.191 0 25c0 9.465 5.227 18.053 13.641 22.512L25 65l11.359-17.488C44.773 43.053 50 34.465 50 25c0-13.809-11.191-25-25-25z"/>
//         <circle cx="25" cy="23" r="20" fill="#FFFFFF" />
//         <text x="25" y="28" text-anchor="middle" fill="#000000" font-size="20" font-weight="bold">${count}</text>
//       </svg>`;

//     const svgBlob = new Blob([svgTemplate], {
//       type: "image/svg+xml;charset=utf-8",
//     });
//     const svgUrl = URL.createObjectURL(svgBlob);

//     return new L.Icon({
//       iconUrl: svgUrl,
//       iconSize: [32, 42],
//       iconAnchor: [16, 42],
//       popupAnchor: [0, -32],
//     });
//   };

//   const transparentIcon = new L.Icon({
//     iconUrl:
//       "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAW0lEQVR42mNkIBIwErwNlUGBgcPlYxv8YI7JSWBZWVkZl0EE2gYJKQVVUmBmZqYGeSCqACRbwWgCgEXL/85V8LbKyxAAAAAElFTkSuQmCC",
//     iconSize: [1, 1],
//   });

//   L.Marker.prototype.options.icon = transparentIcon;

//   useEffect(() => {
//     if (mapRef.current && response.length > 0 && data.length > 0) {
//       setLoading(true);
//       const map = mapRef.current;

//       let supplierRoute = [];
//       response.map((route, index) => {
//         if (
//           data[index].type_ == "ClosestTerminal" ||
//           data[index].type_ == "Supplier"
//         ) {
//           supplierRoute.push(route);
//         }
//       });
//       const routingControl = L.Routing.control({
//         waypoints: supplierRoute,
//         lineOptions: {
//           styles: [{ color: "blue", opacity: 1, weight: 5 }],
//         },
//         routeWhileDragging: true,
//       });
//       routingControl.addTo(map);

//       let OtherRoute = [];
//       response.map((route, index) => {
//         if (
//           data[index].type_ == "Terminal" ||
//           data[index].type_ == "Pilot" ||
//           data[index].type_ == "Plant"
//         ) {
//           OtherRoute.push(route);
//         }
//       });

//       OtherRoute.unshift(supplierRoute[supplierRoute.length - 1]);

//       function chunkArray(array, chunkSize) {
//         const result = [];
//         for (let i = 0; i < array.length; i += chunkSize - 1) {
//           result.push(array.slice(i, i + chunkSize));
//         }
//         return result;
//       }
//       // Example usage:
//       const chunkedArray = chunkArray(OtherRoute, 2);
//       chunkedArray.forEach((item, index) => {
//         const colorIndex = index % 14;
//         const routingControl2 = L.Routing.control({
//           waypoints: item,
//           lineOptions: {
//             styles: [
//               {
//                 color:
//                   FirstExportData?.length === 1
//                     ? "blue"
//                     : generateRandomColor(colorIndex) || "blue",
//                 opacity: 1,
//                 weight: 5,
//               },
//             ],
//           },
//           routeWhileDragging: true,
//         });
//         routingControl2.addTo(map);
//       });

//       routingControlRef.current = routingControl;

//       const plantLatLong = JSON.stringify(response[response?.length - 1]);
//       let secondClosestTerminalIndex = "";
//       let isInclude = [];
//       let isIncludePlant = [];
//       let plantIndex = [];
//       response.map((point, index) => {
//         let marker;
//         isInclude.push(JSON.stringify(point));

//         let count = index + 1;
//         if (data[index].type_ == "ClosestTerminal") {
//           if (isInclude.slice(0, -1).includes(JSON.stringify(point))) {
//             marker = L.marker(point, {
//               icon: customIcon(`1/${index + 1}`),
//             });
//             secondClosestTerminalIndex = index + 1;
//           } else {
//             marker = L.marker(point, {
//               icon: customIcon(`${index + 1}`),
//             });
//           }
//         } else if (data[index].type_ == "Plant") {
//           isIncludePlant.push(JSON.stringify(point));
//           plantIndex.push(index + 1);
//           if (
//             isInclude.slice(0, -1).includes(JSON.stringify(point)) &&
//             plantLatLong?.includes(JSON.stringify(point))
//           ) {
//             marker = L.marker(point, {
//               icon: customIcon(
//                 `1/${secondClosestTerminalIndex || 0}/${index + 1}`
//               ),
//             });
//           } else if (
//             isIncludePlant.slice(0, -1).includes(JSON.stringify(point))
//           ) {
//             marker = L.marker(point, {
//               icon: customIcon(`${plantIndex[0]}/${index + 1}`),
//             });
//           } else {
//             marker = L.marker(point, {
//               icon: customIcon(count),
//             });
//           }
//         } else if(data[index].type_ == "Pilot" && data[index - 1].type_ == "Terminal" && data[index + 1].type_ == "Pilot"){
//           marker = L.marker(point, {
//             icon: customIcon(`${count-2}/${count}`),
//           });
//           const pilotWaypoints = [response[index - 1], point, response[index + 1]];
//           const routingControlPilot = L.Routing.control({
//             waypoints: pilotWaypoints,
//             lineOptions: {
//               styles: [{
//                 color:"teal",
//                 opacity: 1,
//                 weight: 5,
//               }],
//             },
//             routeWhileDragging: true,
//           });
//           routingControlPilot.addTo(map);
//         } else {
//           marker = L.marker(point, {
//             icon: customIcon(count),
//           });
//         }
//         const popupContent = `<b>Waypoint ${index + 1}</b><br>Name: ${
//           data[index].name || "No Name"
//         }`;
//         marker.bindPopup(popupContent);
//         marker.addTo(map);
//       });

//       const delayData = (response?.length - 1 || 5) * 1000;
//       const delay = delayData > 5000 ? delayData : 6000

//       setTimeout(() => {
//         if (response.length > 0) {
//           const markers = response.map((point) => L.marker(point));
//           const group = new L.featureGroup(markers);
//           map.fitBounds(group.getBounds()?.pad(0.1));
//         } else {
//           map.setView([0, 0], 2);
//         }
//       }, delay);

//       setTimeout(() => {
//         setLoading(false);
//       }, 1000);
//     } else {
//       setTimeout(() => {
//         setLoading(false);
//       }, 1000);
//     }

//     return () => {
//       if (routingControlRef.current && mapRef.current) {
//         const map = mapRef.current.leafletElement;
//         if (routingControlRef.current.removeFrom) {
//           console.log("Removing routing control from map...");
//           routingControlRef.current.removeFrom(map);
//           console.log("Routing control removed successfully.");
//         } else {
//           console.log(
//             "removeFrom function not available on routingControlRef.current."
//           );
//         }
//       } else {
//         console.log(
//           "mapRef.current or routingControlRef.current is null or undefined."
//         );
//       }
//     };
//   }, [response, data]);

//   return (
//     <div>
//       <MapContainer
//         center={[39.4037857, -87.4691097]}
//         zoom={0}
//         style={{ height: "500px", width: "100%" }}
//         ref={mapRef}
//       >
//         {loading ? (
//           <div className="loader_center">
//             <Spin size="large" />
//           </div>
//         ) : (
//           <TileLayer
//             url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//             attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
//           />
//         )}

//         {/* <Marker position={[39.4037857, -87.4691097]} icon={customIcon}>
//                       <Popup>Start Marker</Popup>
//                   </Marker>
//                   <Marker position={[29.262515008106, -98.541838982395]} icon={customIcon}>
//                       <Popup>End Marker</Popup>
//                   </Marker> */}
//       </MapContainer>
//     </div>
//   );
// };

// export default MapComponent;
import React, { useRef, useEffect, useState } from "react";
import L from "leaflet";
import { MapContainer, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { Spin } from "antd";
import { useSelector } from "react-redux";

import { generateRandomColor } from "../../../util/helper";

const MapComponent = ({ response, data }) => {
  const mapRef = useRef(null);
  const routingControlRef = useRef(null);
  const ORS_API_KEY = process.env.REACT_APP_ROUTING_API_KEY;

  const { FirstExportData } = useSelector((state) => ({
    FirstExportData: state.relay.getMapCoord.FirstExportData,
  }));

  const [loading, setLoading] = useState(false);

  const customIcon = (count) => {
    const svgTemplate = `
      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="65" viewBox="0 0 50 65">
        <path fill="#FF0000" d="M25 0C11.191 0 0 11.191 0 25c0 9.465 5.227 18.053 13.641 22.512L25 65l11.359-17.488C44.773 43.053 50 34.465 50 25c0-13.809-11.191-25-25-25z"/>
        <circle cx="25" cy="23" r="20" fill="#FFFFFF" />
        <text x="25" y="28" text-anchor="middle" fill="#000000" font-size="20" font-weight="bold">${count}</text>
      </svg>`;

    const svgBlob = new Blob([svgTemplate], {
      type: "image/svg+xml;charset=utf-8",
    });
    const svgUrl = URL.createObjectURL(svgBlob);

    return new L.Icon({
      iconUrl: svgUrl,
      iconSize: [32, 42],
      iconAnchor: [16, 42],
      popupAnchor: [0, -32],
    });
  };

  const transparentIcon = new L.Icon({
    iconUrl:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAW0lEQVR42mNkIBIwErwNlUGBgcPlYxv8YI7JSWBZWVkZl0EE2gYJKQVVUmBmZqYGeSCqACRbwWgCgEXL/85V8LbKyxAAAAAElFTkSuQmCC",
    iconSize: [1, 1],
  });

  L.Marker.prototype.options.icon = transparentIcon;

  // OpenRouteService route handler - simpler implementation to avoid stack overflow
  const createOpenRouteServiceHandler = function (waypoints, lineOptions, zIndex = 0) {
    let routeLayer = null;
    let routeMap = null;
    const routeZIndex = zIndex;

    const getRoute = function (map) {
      routeMap = map;
      if (waypoints.length < 2) return;

      // Convert waypoints from [lat, lng] to [lng, lat] for OpenRouteService
      const coordinates = waypoints.map(wp => [wp[1], wp[0]]);

      fetch('https://api.openrouteservice.org/v2/directions/driving-car/geojson', {
        method: 'POST',
        headers: {
          'Authorization': ORS_API_KEY,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ coordinates: coordinates })
      })
        .then(response => response.json())
        .then(data => {
          if (routeLayer) {
            map.removeLayer(routeLayer);
          }

          routeLayer = L.geoJSON(data, {
            style: function (feature) {
              // Start with the style from lineOptions
              const style = { ...lineOptions.styles[0] };
              // Add the z-index
              style.zIndex = routeZIndex;
              return style;
            }
          }).addTo(map);

          if (routeZIndex > 0) {
            routeLayer.bringToFront();
          } else {
            routeLayer.bringToBack();
          }
        })
        .catch(error => {
          console.error('OpenRouteService error:', error);
        });
    };

    const removeFrom = function (map) {
      if (routeLayer) {
        map.removeLayer(routeLayer);
      }
    };

    return {
      addTo: function (map) {
        getRoute(map);
        return this;
      },
      removeFrom: removeFrom
    };
  };

  // Simple mock for Leaflet Routing Machine
  L.Routing = L.Routing || {};
  L.Routing.control = function (options) {
    return createOpenRouteServiceHandler(options.waypoints, options.lineOptions, options.zIndex || 0);
  };

  useEffect(() => {
    if (mapRef.current && response.length > 0 && data.length > 0) {
      setLoading(true);
      const map = mapRef.current;

      //Supplier route
      let supplierRoute = [];
      response.map((route, index) => {
        if (
          data[index].type_ == "ClosestTerminal" ||
          data[index].type_ == "Supplier"
        ) {
          supplierRoute.push(route);
        }
      });
      const routingControl = L.Routing.control({
        waypoints: supplierRoute,
        lineOptions: {
          styles: [{ color: "blue", opacity: 1, weight: 5 }],
        },
        routeWhileDragging: true,
      });
      routingControl.addTo(map);

      // Other route (Terminal, Pilot, Plant)
      let OtherRoute = [];
      response.map((route, index) => {
        if (
          data[index].type_ == "Terminal" ||
          data[index].type_ == "Pilot" ||
          data[index].type_ == "Plant"
        ) {
          OtherRoute.push(route);
        }
      });

      OtherRoute.unshift(supplierRoute[supplierRoute.length - 1]);

      function chunkArray(array, chunkSize) {
        const result = [];
        for (let i = 0; i < array.length; i += chunkSize - 1) {
          result.push(array.slice(i, i + chunkSize));
        }
        return result;
      }

      const chunkedArray = chunkArray(OtherRoute, 2);
      let lastUsedColor = null;
      for (let i = chunkedArray.length - 1; i >= 0; i--) {
        const item = chunkedArray[i];
        const isLastChunk = i === chunkedArray.length - 2;
        const lastDataType = data[data.length - 1]?.type_ === 'Terminal' && data[data.length - 2]?.type_ === 'Plant' && data[data.length - 3]?.type_ === 'Pilot';

        let color;
        if (FirstExportData?.length === 1) {
          color = "blue";
        } else if (isLastChunk && lastDataType) {
          // Use previous color if last point is Terminal
          color = lastUsedColor || "blue";
        } else {
          color = generateRandomColor(i % 14);
          lastUsedColor = color;
        }

        const zIndex = 900 - (i * 10);

        const routingControl2 = L.Routing.control({
          waypoints: item,
          lineOptions: {
            styles: [
              {
                color: color,
                opacity: 1,
                weight: 5,
              },
            ],
          },
          routeWhileDragging: true,
          zIndex: zIndex
        });
        routingControl2.addTo(map);
      }

      routingControlRef.current = routingControl;

      // Marker rendering
      const plantLatLong = JSON.stringify(response[response?.length - 1]);
      let secondClosestTerminalIndex = "";
      let isInclude = [];
      let isIncludePlant = [];
      let plantIndex = [];
      response.map((point, index) => {
        let marker;
        isInclude.push(JSON.stringify(point));

        let count = index + 1;
        if (data[index].type_ == "ClosestTerminal") {
          if (isInclude.slice(0, -1).includes(JSON.stringify(point))) {
            marker = L.marker(point, {
              icon: customIcon(`1/${index + 1}`),
            });
            secondClosestTerminalIndex = index + 1;
          } else {
            marker = L.marker(point, {
              icon: customIcon(`${index + 1}`),
            });
          }
        } else if (data[index].type_ == "Plant") {
          isIncludePlant.push(JSON.stringify(point));
          plantIndex.push(index + 1);
          if (
            isInclude.slice(0, -1).includes(JSON.stringify(point)) &&
            plantLatLong?.includes(JSON.stringify(point))
          ) {
            marker = L.marker(point, {
              icon: customIcon(
                `1/${secondClosestTerminalIndex || 0}/${index + 1}`
              ),
            });
          } else if (
            isIncludePlant.slice(0, -1).includes(JSON.stringify(point))
          ) {
            marker = L.marker(point, {
              icon: customIcon(`${plantIndex[0]}/${index + 1}`),
            });
          } else {
            marker = L.marker(point, {
              icon: customIcon(count),
            });
          }
        } else if (data[index].type_ == "Pilot" && data[index - 1].type_ == "Terminal" && data[index + 1].type_ == "Pilot") {
          marker = L.marker(point, {
            icon: customIcon(`${count - 2}/${count}`),
          });
          const pilotWaypoints = [response[index - 1], point, response[index + 1]];
          const routingControlPilot = L.Routing.control({
            waypoints: pilotWaypoints,
            lineOptions: {
              styles: [{
                color: "teal",
                opacity: 1,
                weight: 5,
              }],
            },
            routeWhileDragging: true,
          });
          routingControlPilot.addTo(map);
        } else {
          marker = L.marker(point, {
            icon: customIcon(count),
          });
        }
        const popupContent = `<b>Waypoint ${index + 1}</b><br>Name: ${data[index].name || "No Name"
          }`;
        marker.bindPopup(popupContent);
        marker.addTo(map);
      });

      if (response.length > 0) {
        const markers = response.map((point) => L.marker(point));
        const group = new L.featureGroup(markers);
        map.fitBounds(group.getBounds()?.pad(0.1));
      } else {
        map.setView([0, 0], 2);
      }

      setTimeout(() => {
        setLoading(false);
      }, 1000);
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }

    return () => {
      if (routingControlRef.current && mapRef.current) {
        const map = mapRef.current;
        if (routingControlRef.current.removeFrom) {
          console.log("Removing routing control from map...");
          routingControlRef.current.removeFrom(map);
          console.log("Routing control removed successfully.");
        } else {
          console.log(
            "removeFrom function not available on routingControlRef.current."
          );
        }
      } else {
        console.log(
          "mapRef.current or routingControlRef.current is null or undefined."
        );
      }
    };
  }, [response, data]);

  return (
    <div>
      <MapContainer
        center={[39.4037857, -87.4691097]}
        zoom={0}
        style={{ height: "500px", width: "100%" }}
        ref={mapRef}
      >
        {loading ? (
          <div className="loader_center">
            <Spin size="large" />
          </div>
        ) : (
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          />
        )}
      </MapContainer>
    </div>
  );
};

export default MapComponent;

